<template>
  <div class="editReport">
    <div class="headTab">
      <el-tabs v-model="activeName">
        <el-tab-pane label="人才推荐报告" name="first">
          <recommendReport
            :PreCode="PreCode"
            :item="item"
            :id="id"
            :reviewCode="reviewCode"
            :showAutingBtn="Number(showAutingBtn1)"
            :projectCode="projectCode"
            :projectId="projectId"
          >
          </recommendReport>
        </el-tab-pane>
        <el-tab-pane label="背景调查报告" name="second">
          <surveyReport
            :PreCode="PreCode"
            :item="item"
            :id="id"
            :reviewCode="reviewCode"
            :showAutingBtn="Number(showAutingBtn1)"
            :projectCode="projectCode"
            :projectId="projectId"
          ></surveyReport>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import recommendReport from './recommendReport.vue'
import surveyReport from './surveyReport.vue'
export default {
  components: {
    recommendReport,
    surveyReport
  },
  data() {
    return {
      activeName: 'first'
    }
  },
  computed: {
    // 人选id
    PreCode() {
      return this.$route.query.PreCode
    },
    item() {
      return JSON.parse(this.$route.query.item)
    },
    // 項目id
    id() {
      return this.$route.query.id * 1
    },
    type() {
      return this.$route.query.type
    },
    // 审核id
    reviewCode() {
      return this.$route.query.reviewCode
    },
    // 审核按钮是否展示
    showAutingBtn1() {
      return this.$route.query.showAutingBtn
    },
    // 项目id
    projectCode() {
      return this.$route.query.id
    },
    projectId() {
      return this.$route.query.projectCode
    }
  },
  watch: {
    type: {
      handler(newValue, oldValue) {
        if (newValue == '1' && newValue) {
          this.activeName = 'first'
        } else {
          this.activeName = 'second'
        }
      },
      immediate: true
    }
  },
  methods: {},
  created() {}
}
</script>
<style scoped lang="less"></style>
